import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { MySpendingMoneyHelpCardComponent } from './home-cards/my-spending-money-help-card/my-spending-money-help-card.component';
import { MySpendingActionCardComponent } from './home-cards/my-spending-action-card/my-spending-action-card.component';

@Injectable({ providedIn: 'root' })
export class MySpendingCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _unsub$ = new Subject<void>();

  constructor() {
    this._serviceInventory
      .getService('my_spending')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
            case ServiceState.PENDING:
            case ServiceState.COMPLETE:
              this.registerMySpendingMyMoneyHelpCard(service.route);
              if (service.state === ServiceState.PENDING) {
                this.registerMySpendingActionCard(service.route);
              }
              break;
            case ServiceState.MAINTENANCE:
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.next();
  }

  private registerMySpendingMyMoneyHelpCard(route?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'my-spending-moneyhelp',
      component: 'MySpendingMyMoneyHelpCardComponent',
      componentRef: MySpendingMoneyHelpCardComponent,
      section: HomeFeedSection.MYMONEYHELP,
      data: { route },
      order: 3,
    });
  }

  private registerMySpendingActionCard(route?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'payroll',
      component: 'MySpendingActionCardComponent',
      componentRef: MySpendingActionCardComponent,
      section: HomeFeedSection.ACTIONS,
      data: { route },
      order: 50,
    });
  }
}
